





























import Vue from "vue";
import { uuid } from "../utils/uuid";
import Overview from "@/components/Cluster/CluOverview.vue";
import Pthsical from "@/components/Cluster/CluPhysical.vue";
import Etcd from "@/components/Cluster/CluEtcd.vue";
import Scheduler from "@/components/Cluster/CluScheduler.vue";
import Api from "@/components/Cluster/CluApi.vue";
export default Vue.extend({
  name: "Cluster",
  components: { Overview, Pthsical, Etcd, Scheduler, Api },
  data() {
    return {
      tabActive: "overview",
      tabs: [
        { label: "概览", name: "overview", uuid: uuid() },
        { label: "物理资源监控", name: "physical", uuid: uuid() },
        { label: "ETCD监控", name: "ETCO", uuid: uuid() },
        { label: "APIServer监控", name: "API", uuid: uuid() },
        { label: "调度器监控", name: "scheduler", uuid: uuid() }
      ]
    };
  }
});
